import topbar from 'topbar'

let scheduled

topbar.config({ barTickness: 5, barColors: { 0: '#8b9ff8' }, shadowColor: 'rgba(0, 0, 0, .3)' })

window.addEventListener('phx:page-loading-start', () => {
  if (!scheduled) {
    scheduled = setTimeout(() => topbar.show(), 200)
  }
})

window.addEventListener('phx:page-loading-stop', () => {
  clearTimeout(scheduled)
  scheduled = undefined // eslint-disable-line no-undefined
  topbar.hide()
})

window.addEventListener('phx:page-loading-stop', (info) => {
  if (typeof window.Intercom === 'undefined') {
    return
  }

  if (info.detail.kind === 'initial') {
    window.Intercom('boot', window.intercomSettings); // eslint-disable-line new-cap
  } else {
    window.Intercom('update', { last_request_at: parseInt((new Date()).getTime() / 1000, 10) }); // eslint-disable-line new-cap, camelcase
  }

})

window.topbar = topbar

export default { load: () => { } }
